import React from 'react';
import { classNames } from '@pwskills/rachnaui/utils';
import { IIcon } from '../Icons.types';

const Zoom = (props: IIcon) => {
  const { className = '', textColor, ...rest } = props;

  return (
    <svg
      {...rest}
      className={classNames('w-6 h-6', className)}
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M11.0078 19.8223C15.4261 19.8223 19.0078 16.2405 19.0078 11.8223C19.0078 7.40399 15.4261 3.82227 11.0078 3.82227C6.58953 3.82227 3.00781 7.40399 3.00781 11.8223C3.00781 16.2405 6.58953 19.8223 11.0078 19.8223Z"
        stroke={textColor ? `${textColor}` : '#757575'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0063 21.8227L16.6562 17.4727"
        stroke={textColor ? `${textColor}` : '#757575'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0078 8.82227V14.8223"
        stroke={textColor ? `${textColor}` : '#757575'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00781 11.8223H14.0078"
        stroke={textColor ? `${textColor}` : '#757575'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Zoom;
